var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDollar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.445 13.104c0 2.835-2.044 4.725-5.211 5.108V20H8.756v-1.84c-3.09-.433-5.006-2.426-5.006-5.21h3.908c0 1.456.817 2.197 2.426 2.197 1.43 0 2.197-.588 2.197-1.533 0-.996-.536-1.328-1.89-1.634l-2.043-.486c-2.887-.69-4.343-2.273-4.343-4.75 0-2.58 1.865-4.496 4.751-4.905V0h2.478v1.84c2.784.433 4.521 2.221 4.547 4.75h-3.909c0-1.15-.766-1.814-1.992-1.814-1.15 0-1.762.537-1.762 1.43 0 .844.664 1.406 1.966 1.687l1.942.434c2.937.638 4.419 2.248 4.419 4.777Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDollar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dollar.c52aa9911971288279fad27b13a340bb.svg";